import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";

const PayDownModal = () => {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);

  const [amount, setAmount] = useState('');
  const [effectiveDate, setEffectiveDate] = useState('');

  const remainingPrincipal = modal.options?.remainingPrincipal
  const nextPaymentDate = modal.options?.nextPaymentDate

  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
  };

  const handleSchedulePaydown = () => {
    // Implement the logic for scheduling paydown
    // ...
  };

  if (!(modal.is_active && modal.type === 'pay_down')) {
    return null;
  }

  return (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card column is-3">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">
            PayDown
          </p>
          <button className="delete" aria-label="close" onClick={handleCancel}></button>
        </header>
        <section
          className="modal-card-body modal-card-body pt-1 pb-1"
          style={{ height: "170px", overflow: 'hidden' }}
        >
          <div className="columns mb-0 is-flex-direction-column">
            <div className="column has-text-centered">
              <h3> Select the amount for paydown and the effective date.</h3>
              <h3>Remaining Principal: ${remainingPrincipal}</h3>
            </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">Amount:</label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control"></div>
                <input
                  type="number"
                  className="input"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  max={remainingPrincipal}
                />
              </div>
            </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">Schedule Date:</label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control">
                  <input
                    type="date"
                    className="input"
                    value={effectiveDate}
                    onChange={(e) => setEffectiveDate(e.target.value)}
                    max={nextPaymentDate}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleCancel}>Cancel</button>
            <button type="submit" className="button is-link is-small" onClick={handleSchedulePaydown}>Schedule Paydown </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default PayDownModal;
